module.exports = __webpack_public_path__ + "static/media/sn_h_yt.13aa8516.svg";